<template>
    <div class="crm-main-cont">
        <h3 class="main-title">角色管理</h3>

        <div class="role-list-box" v-show="systemLevel === 1">
            <span class="role-title">省级角色</span>
            <ul class="role-list clearfix">
                <li :key="province.id" v-for="province in provinceList">
                    <a-row>
                      <a-col :span="12">
                        <a-input
                            :disabled="province.editStatus ? false : 'disabled'"
                            v-model="province.name"
                        ></a-input>
                      </a-col>
                      <a-col :span="12">
                        <a-select v-model="province.type"  style="width: 120px; margin-left: 10px"
                                  :disabled="province.editStatus ? false : 'disabled'">
                          <a-select-option value="1">
                            系统管理
                          </a-select-option>
                          <a-select-option value="2">
                            运营管理
                          </a-select-option>
                          <a-select-option value="3">
                            金融机构
                          </a-select-option>
                          <a-select-option value="6">
                            个人用户
                          </a-select-option>
                          <a-select-option value="7">
                            企业用户
                          </a-select-option>
                        </a-select>
                      </a-col>
                    </a-row>


                    <a
                        class="edit-btn"
                        v-show="!province.editStatus"
                        href="javascript:;"
                        @click="handleEdit(province.id, 1)"
                        >编辑</a
                    >
                    <a
                        class="edit-btn2"
                        v-show="!province.editStatus"
                        href="javascript:;"
                        @click="handleDelete(province.id, 1)"
                        >删除</a
                    >
                    <a
                        class="edit-btn"
                        v-show="province.editStatus"
                        href="javascript:;"
                        @click="handleUpdate(province.id, 1)"
                        >确定</a
                    >
                    <a
                        class="edit-btn2"
                        v-show="province.editStatus"
                        href="javascript:;"
                        @click="handleCancel(province.id, 1)"
                        >取消</a
                    >
                </li>
                <li>
                  <a-row>
                    <a-col :span="12">

                      <a-input v-model="provinceText"></a-input>
                    </a-col>
                    <a-col :span="12">
                      <a-select default-value="1" v-model="typeAdd" style="width: 120px; margin-left: 10px">
                        <a-select-option value="1">
                          系统管理
                        </a-select-option>
                        <a-select-option value="2">
                          运营管理
                        </a-select-option>
                        <a-select-option value="3">
                          金融机构
                        </a-select-option>
                        <a-select-option value="6">
                          个人用户
                        </a-select-option>
                        <a-select-option value="7">
                          企业用户
                        </a-select-option>
                      </a-select>
                    </a-col>
                  </a-row>

                    <a
                        class="edit-btn"
                        href="javascript:;"
                        @click="handleAdd(1)"
                        >添加</a
                    >
                </li>
            </ul>
        </div>
        <div class="role-list-box" v-show="systemLevel < 3">
            <span class="role-title">市级角色</span>
            <ul class="role-list clearfix">
                <li :key="city.id" v-for="city in cityList">
                    <a-row>
                      <a-col :span="12">
                        <a-input
                            :disabled="city.editStatus ? false : 'disabled'"
                            v-model="city.name"
                        ></a-input>
                      </a-col>
                      <a-col :span="12">
                        <a-select v-model="city.type" style="width: 120px; margin-left: 10px"
                                  :disabled="city.editStatus ? false : 'disabled'"
                                  @change="handleChange">
                          <a-select-option value="1">
                            系统管理
                          </a-select-option>
                          <a-select-option value="2">
                            运营管理
                          </a-select-option>
                          <a-select-option value="3">
                            金融机构
                          </a-select-option>
                          <a-select-option value="6">
                            个人用户
                          </a-select-option>
                          <a-select-option value="7">
                            企业用户
                          </a-select-option>
                        </a-select>
                      </a-col>
                    </a-row>
                    <a
                        class="edit-btn"
                        v-show="!city.editStatus"
                        href="javascript:;"
                        @click="handleEdit(city.id, 2)"
                        >编辑</a
                    >
                    <a
                        class="edit-btn2"
                        v-show="!city.editStatus"
                        href="javascript:;"
                        @click="handleDelete(city.id, 1)"
                        >删除</a
                    >
                    <a
                        class="edit-btn"
                        v-show="city.editStatus"
                        href="javascript:;"
                        @click="handleUpdate(city.id, 2)"
                        >确定</a
                    >
                    <a
                        class="edit-btn2"
                        v-show="city.editStatus"
                        href="javascript:;"
                        @click="handleCancel(city.id, 2)"
                        >取消</a
                    >
                </li>
                <li>
                    <a-row>
                      <a-col :span="12">
                        <a-input v-model="cityText"></a-input>
                      </a-col>
                      <a-col :span="12">
                        <a-select default-value="1" v-model="typeAdd2" style="width: 120px; margin-left: 10px">
                          <a-select-option value="1">
                            系统管理
                          </a-select-option>
                          <a-select-option value="2">
                            运营管理
                          </a-select-option>
                          <a-select-option value="3">
                            金融机构
                          </a-select-option>
                          <a-select-option value="6">
                            个人用户
                          </a-select-option>
                          <a-select-option value="7">
                            企业用户
                          </a-select-option>
                        </a-select>
                      </a-col>
                    </a-row>
                    <a
                        class="edit-btn"
                        href="javascript:;"
                        @click="handleAdd(2)"
                        >添加</a
                    >
                </li>
            </ul>
        </div>
        <div class="role-list-box">
            <span class="role-title">区级角色</span>
            <ul class="role-list clearfix">
                <li :key="district.id" v-for="district in districtList">
                  <a-row>
                    <a-col :span="12">
                      <a-input
                          :disabled="district.editStatus ? false : 'disabled'"
                          v-model="district.name"
                      ></a-input>
                    </a-col>
                    <a-col :span="12">
                      <a-select v-model="district.type" style="width: 120px; margin-left: 10px"
                                :disabled="district.editStatus ? false : 'disabled'">
                        <a-select-option value="1" >
                          系统管理
                        </a-select-option>
                        <a-select-option value="2" >
                          运营管理
                        </a-select-option>
                        <a-select-option value="3" >
                          金融机构
                        </a-select-option>
                        <a-select-option value="6" >
                          个人用户
                        </a-select-option>
                        <a-select-option value="7" >
                          企业用户
                        </a-select-option>
                      </a-select>
                    </a-col>
                  </a-row>

                    <a
                        class="edit-btn"
                        v-show="!district.editStatus"
                        href="javascript:;"
                        @click="handleEdit(district.id, 3)"
                        >编辑</a
                    >
                    <a
                        class="edit-btn2"
                        v-show="!district.editStatus"
                        href="javascript:;"
                        @click="handleDelete(district.id, 1)"
                        >删除</a
                    >
                    <a
                        class="edit-btn"
                        v-show="district.editStatus"
                        href="javascript:;"
                        @click="handleUpdate(district.id, 3)"
                        >确定</a
                    >
                    <a
                        class="edit-btn2"
                        v-show="district.editStatus"
                        href="javascript:;"
                        @click="handleCancel(district.id, 3)"
                        >取消</a
                    >
                </li>
                <li>
                    <a-row>
                      <a-col :span="12">
                        <a-input v-model="districtText"></a-input>
                      </a-col>
                      <a-col :span="12">
                        <a-select default-value="1" v-model="typeAdd3" style="width: 120px; margin-left: 10px">
                          <a-select-option value="1">
                            系统管理
                          </a-select-option>
                          <a-select-option value="2">
                            运营管理
                          </a-select-option>
                          <a-select-option value="3">
                            金融机构
                          </a-select-option>
                          <a-select-option value="6">
                            个人用户
                          </a-select-option>
                          <a-select-option value="7">
                            企业用户
                          </a-select-option>
                        </a-select>
                      </a-col>
                    </a-row>
                    <a
                        class="edit-btn"
                        href="javascript:;"
                        @click="handleAdd(3)"
                        >添加</a
                    >
                </li>
            </ul>
        </div>
        <div class="role-list-box">
            <span class="role-title">其他角色</span>
            <ul class="role-list clearfix">
              <li :key="other.id" v-for="other in otherList">
                <a-row>
                  <a-col :span="12">
                    <a-input
                        :disabled="other.editStatus ? false : 'disabled'"
                        v-model="other.name"
                    ></a-input>
                  </a-col>
                  <a-col :span="12">
                    <a-select v-model="other.type" style="width: 120px; margin-left: 10px"
                              :disabled="other.editStatus ? false : 'disabled'">
                      <a-select-option value="1" >
                        系统管理
                      </a-select-option>
                      <a-select-option value="2" >
                        运营管理
                      </a-select-option>
                      <a-select-option value="3" >
                        金融机构
                      </a-select-option>
                      <a-select-option value="6" >
                        个人用户
                      </a-select-option>
                      <a-select-option value="7" >
                        企业用户
                      </a-select-option>
                    </a-select>
                  </a-col>
                </a-row>

                <a
                    class="edit-btn"
                    v-show="!other.editStatus"
                    href="javascript:;"
                    @click="handleEdit(other.id, -1)"
                >编辑</a
                >
                <a
                    class="edit-btn2"
                    v-show="!other.editStatus"
                    href="javascript:;"
                    @click="handleDelete(other.id, 1)"
                >删除</a
                >
                <a
                    class="edit-btn"
                    v-show="other.editStatus"
                    href="javascript:;"
                    @click="handleUpdate(other.id, -1)"
                >确定</a
                >
                <a
                    class="edit-btn2"
                    v-show="other.editStatus"
                    href="javascript:;"
                    @click="handleCancel(other.id, -1)"
                >取消</a
                >
              </li>
              <li>
                <a-row>
                  <a-col :span="12">
                    <a-input v-model="otherText"></a-input>
                  </a-col>
                  <a-col :span="12">
                    <a-select default-value="1" v-model="typeAdd4" style="width: 120px; margin-left: 10px">
                      <a-select-option value="1">
                        系统管理
                      </a-select-option>
                      <a-select-option value="2">
                        运营管理
                      </a-select-option>
                      <a-select-option value="3">
                        金融机构
                      </a-select-option>
                      <a-select-option value="6">
                        个人用户
                      </a-select-option>
                      <a-select-option value="7">
                        企业用户
                      </a-select-option>
                    </a-select>
                  </a-col>
                </a-row>
                <a
                    class="edit-btn"
                    href="javascript:;"
                    @click="handleAdd(-1)"
                >添加</a
                >
              </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { getAll, addRole, deleteRole, updateRole } from "@/api/yhgl/role";

export default {
    name: "RoleManage",
    data() {
        return {
            otherList: [],
            provinceList: [],
            oldProvinceList: [],
            cityList: [],
            oldCityList: [],
            districtList: [],
            oldDistrictList: [],
            oldOtherList: [],
            provinceText: "",
            cityText: "",
            districtText: "",
            systemLevel: 1,
            otherText: "",
            typeAdd: "",
            typeAdd2: "",
            typeAdd3: "",
            typeAdd4: "",
        };
    },
    beforeRouteEnter(to, from, next) {
        getAll()
            .then(res => {
                next(vm => {
                    vm.$ajaxAfter(res).then(() => {
                        vm.setData(res);
                    });
                });
            })
            .catch(() => {
                next(vm => {
                    vm.$message.error("服务器出错！请稍后再试!");
                    vm.$Progress.fail();
                });
            });
    },
    methods: {
        getData() {
            getAll()
                .then(res => {
                    this.$ajaxAfter(res).then(() => {
                        this.setData(res);
                    });
                })
                .catch(() => {
                    this.$message.error("服务器出错！请稍后再试!");
                });
        },
        setData(res) {
            this.systemLevel = res.data.data.systemLevel;
            console.log(res.data.data.result);
            if (res.data.data.result[-1]) {
              this.otherList = res.data.data.result[-1];
              for (let i=0; i<this.otherList.length; i++) {
                if (this.otherList[i].type === 1) {
                  this.otherList[i].type = "系统管理";
                } else if (this.otherList[i].type === 2) {
                  this.otherList[i].type = "运营管理";
                } else if (this.otherList[i].type === 3) {
                  this.otherList[i].type = "金融机构";
                } else if (this.otherList[i].type === 6) {
                  this.otherList[i].type = "个人用户";
                } else if (this.otherList[i].type === 7) {
                  this.otherList[i].type = "企业用户";
                }
              }

              this.oldOtherList = JSON.parse(
                  JSON.stringify(res.data.data.result[-1])
              );
            }
            if (res.data.data.result[1]) {
                this.provinceList = res.data.data.result[1];
                for (let i=0; i<this.provinceList.length; i++) {
                  if (this.provinceList[i].type === 1) {
                    this.provinceList[i].type = "系统管理";
                  } else if (this.provinceList[i].type === 2) {
                    this.provinceList[i].type = "运营管理";
                  } else if (this.provinceList[i].type === 3) {
                    this.provinceList[i].type = "金融机构";
                  } else if (this.provinceList[i].type === 6) {
                    this.provinceList[i].type = "个人用户";
                  } else if (this.provinceList[i].type === 7) {
                    this.provinceList[i].type = "企业用户";
                  }
                }

                this.oldProvinceList = JSON.parse(
                    JSON.stringify(res.data.data.result[1])
                );
            }

            if (res.data.data.result[2]) {
                this.cityList = res.data.data.result[2];
                for (let i=0; i<this.cityList.length; i++) {
                  if (this.cityList[i].type === 1) {
                    this.cityList[i].type = "系统管理";
                  } else if (this.cityList[i].type === 2) {
                    this.cityList[i].type = "运营管理";
                  } else if (this.cityList[i].type === 3) {
                    this.cityList[i].type = "金融机构";
                  } else if (this.cityList[i].type === 6) {
                    this.cityList[i].type = "个人用户";
                  } else if (this.cityList[i].type === 7) {
                    this.cityList[i].type = "企业用户";
                  }
                }
                this.oldCityList = JSON.parse(
                    JSON.stringify(res.data.data.result[2])
                );
            }

            if (res.data.data.result[3]) {
                this.districtList = res.data.data.result[3];
                for (let i=0; i<this.districtList.length; i++) {
                  if (this.districtList[i].type === 1) {
                    this.districtList[i].type = "系统管理";
                  } else if (this.districtList[i].type === 2) {
                    this.districtList[i].type = "运营管理";
                  } else if (this.districtList[i].type === 3) {
                    this.districtList[i].type = "金融机构";
                  } else if (this.districtList[i].type === 6) {
                    this.districtList[i].type = "个人用户";
                  } else if (this.districtList[i].type === 7) {
                    this.districtList[i].type = "企业用户";
                  }
                }
                this.oldDistrictList = JSON.parse(
                    JSON.stringify(res.data.data.result[3])
                );
            }
        },
        /**
         * 注意这里的level 1省级 2市级 3区级  以下都是一样的
         * @param level
         */
        handleAdd(level) {
            let name;
            let type;
            switch (level) {
                case 1:
                    name = this.provinceText;
                    type = this.typeAdd;
                    break;
                case 2:
                    name = this.cityText;
                    type = this.typeAdd2;
                    break;
                case 3:
                    name = this.districtText;
                    type = this.typeAdd3;
                    break;
                case -1:
                    name = this.otherText;
                    type = this.typeAdd4;
                    break;
            }
            if (!name) {
                this.$message.error("请填写角色名称后再进行添加！");
                return false;
            }
            if (!type) {
              this.$message.error("请填写角色类型后再进行添加！");
              return false;
            }
            addRole({
                name,
                level,
                type
            })
                .then(res => {
                    this.$ajaxAfter(res).then(() => {
                        this.$message.success("添加成功！");
                        if (type === "1") {
                          type = "系统管理";
                        } else if (type === "2") {
                          type = "运营管理";
                        } else if (type === "3") {
                          type = "金融机构";
                        } else if (type === "6") {
                          type = "个人用户";
                        } else if (type === "7") {
                          type = "企业用户";
                        }
                        this.addSuccess(res.data.data.id, level, type);
                        switch (level) {
                          case 1:
                            this.typeAdd = "";
                            break;
                          case 2:
                            this.typeAdd2 = "";
                            break;
                          case 3:
                            this.typeAdd3 = "";
                            break;
                          case -1:
                            this.typeAdd4 = "";
                            break;
                        }
                    });
                })
                .catch(() => {
                    this.$message.error("服务器出错！请稍后再试!");
                });

        },
        addSuccess(id, level, type) {
            let list = [];

            switch (level) {
                case 1:
                    this.provinceList.push({ id: id, name: this.provinceText, type: type });
                    list = JSON.parse(JSON.stringify(this.provinceList));
                    this.oldProvinceList = list;
                    this.provinceText = "";
                    break;
                case 2:
                    this.cityList.push({ id: id, name: this.cityText, type: type  });
                    list = JSON.parse(JSON.stringify(this.cityList));
                    this.oldCityList = list;
                    this.cityText = "";
                    break;
                case 3:
                    this.districtList.push({ id: id, name: this.districtText, type: type  });
                    list = JSON.parse(JSON.stringify(this.districtList));
                    this.oldDistrictList = list;
                    this.districtText = "";
                    break;
                case -1:
                  this.otherList.push({ id: id, name: this.otherText, type: type  });
                  list = JSON.parse(JSON.stringify(this.otherList));
                  this.oldOtherList = list;
                  this.otherText = "";
                  break;
            }
        },
        handleEdit(id, level) {
            let list = [];

            switch (level) {
                case 1:
                    list = [...this.provinceList];
                    break;
                case 2:
                    list = [...this.cityList];
                    break;
                case 3:
                    list = [...this.districtList];
                    break;
                case -1:
                  list = [...this.otherList];
                  break;
            }
            list.map((category, index) => {
                if (id === category.id) {
                    this.$set(list[index], "editStatus", true);
                    return false;
                }
            });
        },
        handleCancel(id, level) {
            let oldList = [],
                list = [];
            switch (level) {
                case 1:
                    oldList = [...this.oldProvinceList];
                    list = this.provinceList;
                    break;
                case 2:
                    oldList = [...this.oldCityList];
                    list = this.cityList;
                    break;
                case 3:
                    oldList = [...this.oldDistrictList];
                    list = this.districtList;
                    break;
                case -1:
                  oldList = [...this.oldOtherList];
                  list = this.otherList;
                  break;
            }
            oldList.map((category, index) => {
                if (id === category.id) {
                    this.$set(list, index, Object.assign({}, category));
                    return false;
                }
            });
        },
        handleDelete(id) {
            deleteRole(id)
                .then(res => {
                    this.$ajaxAfter(res).then(() => {
                        this.$message.success("删除成功！");
                        this.getData();
                    });
                })
                .catch(() => {
                    this.$message.error("服务器出错！请稍后再试!");
                });
        },
        handleUpdate(id, level) {
            let list = [];
            switch (level) {
                case 1:
                    list = [...this.provinceList];
                    break;
                case 2:
                    list = [...this.cityList];
                    break;
                case 3:
                    list = [...this.districtList];
                    break;
                case -1:
                    list = [...this.otherList];
                    break;
            }

            list.map(category => {
                if (id === category.id) {
                    updateRole({ id: category.id, name: category.name, type: category.type })
                        .then(res => {
                            this.$ajaxAfter(res).then(() => {
                                this.$message.success("修改成功！");
                                this.getData();
                            });
                        })
                        .catch(() => {
                            this.$message.error("服务器出错！请稍后再试!");
                        });
                    return false;
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
.main-title {
    font-size: 14px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;
    margin-bottom: 30px;
}
.role-list-box {
    display: flex;
    margin-bottom: 30px;
    line-height: 32px;

    .role-title {
        font-size: 14px;
        margin-right: 30px;
    }
    .role-list {
        width: 80%;
        li {
            width: 45%;
            display: flex;
            float: left;
            margin-right: 2%;
            margin-bottom: 20px;
            padding: 0 10px;
        }
        .edit-btn {
            flex-shrink: 0;
            margin-left: 0px;
        }
        .edit-btn2 {
          flex-shrink: 0;
          margin-left: 10px;
        }
    }
}
</style>
